import { EffectCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useResetOnboardingMutation } from '../../../graphql/gen/types';

const RESET_ONBOARDING_PARAM = 'cmd_reset_onboarding';

/**
 * For debugging purposes it's useful to have a way to reset the onboarding state
 */
export function useResetOnboardingOnCommand(): void {
  const history = useHistory();
  const [resetOnboarding] = useResetOnboardingMutation();

  const { search } = history.location;
  const searchParams = new URLSearchParams(search);

  useEffectOnce(() => {
    if (searchParams.has(RESET_ONBOARDING_PARAM)) {
      searchParams.delete(RESET_ONBOARDING_PARAM);
      resetOnboarding();
      history.replace({
        ...history.location,
        search: searchParams.toString(),
      });
    }
  });
}

const useEffectOnce = (effect: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};
